<template>
  <div class="ContainterEscrevaAqui">
    <b-modal
      centered
      size="md"
      id="avisoBanimento"
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <p class="titleModal text-center">Atenção!</p>
      <p class="title2 text-center">
        Você está enviando muitas postagens em um curto período de tempo. Se você enviar
        mais uma postagem, será bloqueado de enviar postagem temporariamente!
      </p>
      <b-row class="areabutton" align-h="center">
        <b-button id="buttonOk" class="buttonOk" @click="hideModal('avisoBanimento')"
          >OK!</b-button
        >
      </b-row>
    </b-modal>
    <b-modal
      centered
      size="md"
      id="Banimento"
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <p class="titleModal text-center">Atenção!</p>
      <p class="title2 text-center">
        Você enviou muitas postagens em um curto período de tempo e foi banido de realizar
        novas postagens temporariamente!
      </p>
      <b-row class="areabutton" align-h="center">
        <b-button id="buttonOk" class="buttonOk" @click="hideModal('Banimento')"
          >OK!</b-button
        >
      </b-row>
    </b-modal>
    <b-modal
      centered
      size="md"
      id="modalconfirm"
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <p class="titleModal text-center">Seu texto foi enviado com sucesso!</p>
      <p class="title2 text-center">
        Assim que ele for aprovado, ele será exibido juntamente com as outras postagens
      </p>
      <b-row class="areabutton" align-h="center">
        <b-button id="buttonOk" class="buttonOk" @click="hideModal('modalconfirm')"
          >OK!</b-button
        >
      </b-row>
    </b-modal>
    <b-row class="linha" align-h="center">
      <b-col cols="10" md="8" lg="8">
        <b-input-group>
          <b-form-input
            id="textarea-small"
            class="inputSearch"
            size="md"
            placeholder="Remetente (opcional)"
            v-model="dados.mailer"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="10" md="8" lg="8">
        <b-input-group>
          <b-form-input
            id="textarea-small"
            class="inputSearch"
            size="md"
            placeholder="Título"
            v-model="dados.title"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="10" md="8" lg="8">
        <b-form-textarea
          id="textarea-small"
          class="inputSearchMessage"
          size="md"
          placeholder="Mensagem"
          v-model="dados.message"
        ></b-form-textarea>
      </b-col>
      <b-col cols="10" md="8" lg="8">
        <b-button @click="adicionar" id="button" class="buttonEnviar">Enviar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { PostAnonymous } from '@/services/api/AnonymousContact.js';
export default {
  data() {
    return {
      dados: {
        message: '',
        mailer: '',
        title: '',
      },
    };
  },
  methods: {
    hideModal(id) {
      this.$root.$emit('bv::hide::modal', id, '#btnShow');
      this.$router.push({ name: 'HomePostagens' });
    },
    adicionar() {
      PostAnonymous(this.dados)
        .then((res) => {
          if (res.data.client.anonymous_contact.requests == 4) {
            this.$root.$emit('bv::show::modal', 'avisoBanimento', '#btnShow');
            this.dados.message = '';
            this.dados.mailer = '';
            this.dados.title = '';
          } else {
            this.$root.$emit('bv::show::modal', 'modalconfirm', '#btnShow');
          }
        })
        .catch((err) => {
          if (
            err.response.data.erro ==
            'Usuário fez muitas requisições, e será banido por um tempo'
          ) {
            this.$root.$emit('bv::show::modal', 'Banimento', '#btnShow');
          } else if (err.response.data.erro == 'O titulo é obrigatório') {
            alert('Campo de Título é obrigatório!');
          } else if (err.response.data.erro == 'A mensagem é obrigatória') {
            alert('Campo de Mensagem é obrigatório!');
          } else {
            alert(
              'Não foi possível enviar sua postagem - Banimento temporário ou Erro Interno!',
            );
            this.dados.message = '';
            this.dados.mailer = '';
            this.dados.title = '';
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  background-color: #fffaf4;
}
input,
button,
select,
optgroup,
textarea {
  font-family: 'Montserrat', sans-serif;
}
.btn:hover {
  font-weight: bold;
}
.buttonEnviar {
  border-color: #a33965;
}
.linha.row {
  margin: 0;
}
.titleModal {
  text-align: center;
  font-family: 'Noto Sans', sans-serif;
  font-weight: bold;
  font-size: 1.5rem;
  background-color: white;
}
.title2 {
  font-size: 1.2rem;
  background-color: white;
}
#modalconfirm {
  background-color: white;
}
.areabutton {
  background-color: white;
}
.buttonOk.btn-secondary {
  background-color: #a33965 !important;
  width: 6rem;
}
.inputSearch {
  background-color: transparent !important;
  border: none;
  border-radius: 0px;
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 2rem;
}
.inputSearchMessage {
  height: 10rem;
  background-color: transparent !important;
  border: none;
  border-radius: 0px;
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 2rem;
}
</style>
<style lang="scss">
.ContainterEscrevaAqui {
  #button.buttonEnviar.btn-secondary {
    background-color: #a33965 !important;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }
}
</style>
